import { Link } from "react-router-dom";
import { featuredCollections, movies } from "@/mocks/movies";
import MovieCard from "@/components/base/MovieCard";

export default function FeatureSection() {
  return (
    <section className="bg-background-100/70 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">精选专题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精心策划的影视专题，帮你快速找到心仪的影片
          </p>
        </div>

        <div className="flex flex-col gap-10">
          {featuredCollections.map((collection) => {
            const collectionMovies = collection.movieIds
              .map((id) => movies.find((m) => m.id === id))
              .filter(Boolean);

            return (
              <div key={collection.id}>
                <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-5 gap-3">
                  <div>
                    <div className="flex items-center gap-3 mb-1">
                      <span className="px-2.5 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap bg-accent-100 text-accent-700">
                        专题
                      </span>
                      <h3 className="text-lg md:text-xl font-bold text-foreground-950">{collection.title}</h3>
                    </div>
                    <p className="text-sm text-foreground-500">{collection.description}</p>
                  </div>
                  <Link
                    to={`/category/action`}
                    className="text-sm text-accent-600 hover:text-accent-700 font-medium whitespace-nowrap cursor-pointer transition-colors duration-200"
                  >
                    查看更多 <i className="ri-arrow-right-line ml-1 text-xs"></i>
                  </Link>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                  {collectionMovies.map((movie) => movie && (
                    <MovieCard
                      key={movie.id}
                      id={movie.id}
                      title={movie.title}
                      category={movie.category}
                      year={movie.year}
                      rating={movie.rating}
                      imageUrl={movie.imageUrl}
                    />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}